<template>
  <div>
    <div style="text-align: center; margin-top: 5%">
      <img :src="require('@/assets/img/404.png')" style="width: 50%" />
    </div>
  </div>
</template>
<script>
export default {};
</script>
